import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import Paragraph from 'evcharging/components/Paragraph';
import Box from 'evcharging/components/Box';
import Responsible from 'evcharging/components/Responsible';
import Spacer from 'evcharging/components/Spacer';
import ProductImagesSlider from 'evcharging/containers/ev-charger/ProductImagesSlider';
import DistanceCalculator from 'evcharging/containers/ev-charger/DistanceCalculator';
import Certification from 'evcharging/containers/ev-charger/Certification';
import useI18n from 'evcharging/hooks/useI18n';
import React from 'react';

const ProductImages = () => {
  const { t } = useI18n();

  return (
    <Section>
      <Container maxWidth={1070}>
        <Responsible fractions={[49, 48]}>
          <ProductImagesSlider />
          <Box>
            <Spacer value={35} mobile={0} />
            <Title variant={'h2'}>{t('charger.images.title')}</Title>
            <Spacer value={16} />
            <Paragraph color={'middle'}>{t('charger.intro')}</Paragraph>
            <Spacer value={48} mobile={24} />
            <DistanceCalculator />
            <Spacer value={84} mobile={48} />
            <Certification />
          </Box>
        </Responsible>
      </Container>
    </Section>
  );
};

export default ProductImages;
